export const suggestionLinkStyles = {
    display: "inline",
    fontSize: "inherit",
    lineHeight: "inherit",
    letterSpacing: "inherit",
    fontWeight: "bold",
    textDecoration: "none",
    borderBottom: "1.5px solid currentColor",
    borderRadius: 0,
    padding: 0,
    background: "transparent",
    height: "auto",
    minH: "unset",
    textAlign: "start",
    cursor: "pointer",
    verticalAlign: "baseline",
} as const;

export const didYouMeanHeadingStyles = {
    mt: 4,
    fontWeight: "normal",
} as const;
